/* eslint-disable react/jsx-no-target-blank */
import React, { Component } from "react";
import { connect } from "react-redux";
import Logo from "../styles/img/logo-full.png";
import { MD_Meta_Data } from "../actions/assetAction";
import { Spin } from "antd";

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      driver: "",
      manager: "",
      web: "",
      driver_scandit: "",
    };
  }

  componentDidMount() {
    this.props
      .MD_Meta_Data()
      .then((res) => {
        console.log(res);
        this.setState({
          demodriver: res.driver,
          manager: res.manager,
          web: res.web,
          loading: false,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          loading: false,
        });
      });
  }

  render() {
    return (
      <div>
        <div className="container-fluid allproduct">
          <Spin spinning={this.state.loading}>
            <div className="container">
              <div className="row g-2 height d-flex justify-content-center align-items-center">
                <div className="col-md-6">
                  <div className="text-center">
                    <h2 className="text-uppercase">Welcome! User</h2>

                    <div className="buttons justify-content-center mt-3">
                      <a href={this.state.demodriver}>
                        <button className="btn btn-dark app-button mt-3 mb-b">
                          <span className="text-uppercase ml-2">
                            Driver App
                          </span>
                        </button>
                      </a>

                      <a href={this.state.manager}>
                        <button className="btn btn-dark app-button mt-3 mb-b">
                          <span className="text-uppercase ml-2">
                            Manager App
                          </span>
                        </button>
                      </a>
                      <a href={this.state.web} target="_blank">
                        <button className="btn btn-dark app-button mt-3 mb-b">
                          <span className="text-uppercase ml-2">
                            Agent Web App
                          </span>
                        </button>
                      </a>
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="text-center">
                    <img src={Logo} width="400" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </Spin>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    user: state.user,
  };
}
export default connect(mapStateToProps, { MD_Meta_Data })(Dashboard);
